import { Reveal, Chapter } from "@/components/Reveal";
import { openConversation } from "@/components/Conversation";

const Contact = () => (
  <section id="contact" data-testid="contact-section" className="bg-ink text-ivory py-28 lg:py-40">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <Reveal>
        <Chapter number="11" label="Contact" dark />
      </Reveal>
      <div className="grid lg:grid-cols-12 gap-14 lg:gap-24">
        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-7xl font-light leading-[1.05]">
              Secure Operational <span className="italic text-bronze">Distinction</span>
            </h2>
            <p className="mt-8 font-serif text-2xl lg:text-3xl font-light italic text-ivory/80">
              Let&apos;s Build Your Team.
            </p>
            <p className="mt-6 text-sm text-ivory/55 leading-relaxed max-w-xl">
              Connect with BR Hospitality to discuss recruitment, hospitality advisory or an
              upcoming pre-opening project.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <button
              data-testid="contact-cta-conversation"
              onClick={openConversation}
              className="mt-10 text-[11px] tracking-[0.25em] uppercase px-8 py-4 bg-bronze text-ink hover:bg-ivory transition-colors duration-500"
            >
              Start a Conversation
            </button>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.2}>
            <div className="border border-ivory/15 p-10 lg:p-12">
              <p className="font-serif text-xl tracking-[0.15em]">BR HOSPITALITY</p>
              <p className="text-[9px] tracking-[0.4em] uppercase text-bronze mt-1 mb-10">
                Recruitment &amp; Advisory
              </p>
              <dl className="space-y-6">
                <div>
                  <dt className="text-[9px] tracking-[0.3em] uppercase text-ivory/40 mb-1">Website</dt>
                  <dd className="text-sm text-ivory/80" data-testid="contact-website">br-hospitality.com</dd>
                </div>
                <div>
                  <dt className="text-[9px] tracking-[0.3em] uppercase text-ivory/40 mb-1">Email</dt>
                  <dd>
                    <a
                      href="mailto:info@br-hospitality.com"
                      data-testid="contact-email"
                      className="text-sm text-ivory/80 link-underline hover:text-bronze transition-colors duration-500"
                    >
                      info@br-hospitality.com
                    </a>
                  </dd>
                </div>
                <div>
                  <dt className="text-[9px] tracking-[0.3em] uppercase text-ivory/40 mb-1">Phone / WhatsApp (UAE)</dt>
                  <dd>
                    <a
                      href="tel:+971553087187"
                      data-testid="contact-phone-uae"
                      className="text-sm text-ivory/80 link-underline hover:text-bronze transition-colors duration-500"
                    >
                      +971 55 308 7187
                    </a>
                  </dd>
                </div>
                <div>
                  <dt className="text-[9px] tracking-[0.3em] uppercase text-ivory/40 mb-1">Phone (Philippines)</dt>
                  <dd>
                    <a
                      href="tel:+639953544784"
                      data-testid="contact-phone"
                      className="text-sm text-ivory/80 link-underline hover:text-bronze transition-colors duration-500"
                    >
                      +63 995 354 4784
                    </a>
                  </dd>
                </div>
                <div>
                  <dt className="text-[9px] tracking-[0.3em] uppercase text-ivory/40 mb-1">Region</dt>
                  <dd className="text-sm text-ivory/80" data-testid="contact-region">
                    Europe · Middle East · Asia
                  </dd>
                </div>
              </dl>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Contact;
